<script lang="ts">
import { defineComponent } from "vue";
import ContactSticky from "@/layout/ContactSticky.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "GevHeader",
  components: { ContactSticky },
  props: {
    produkt: {
      type: String,
      default: "",
    },
  },
  setup() {
    const piniaStore = useFormStore();

    const zeigeFachbereich = process.env.VUE_APP_LOG_LEVEL === "trace";
    const startseite = process.env.VUE_APP_HOME_URL;

    return {
      piniaStore,
      zeigeFachbereich,
      startseite,
    };
  },
});
</script>

<template>
  <header id="header" class="o-container header">
    <div class="header_meta-nav o-container__remove">&nbsp;</div>
    <div class="header_logo">
      <a :href="startseite">
        <img
          src="@/assets/static/images/logo_uz.svg"
          class="c-header__logo"
          alt="Logo GEV"
          title="Zur Startseite der GEV Versicherung"
        />
      </a>
    </div>
    <div class="header_category" v-if="produkt">
      <p>
        {{ produkt }}
        <span v-if="zeigeFachbereich">
          <span v-if="piniaStore.state.isMakler">Makler</span>
          <span v-else>Direkt</span>
        </span>
      </p>
    </div>
    <div class="header_spacer o-container__remove">&nbsp;</div>
  </header>
  <contact-sticky :is-makler="piniaStore.state.isMakler" />
</template>

<style></style>
